export { Icon } from './components/Icon';
export { StarFullSvgComponent as StarIcon } from './icons/stars';
export { CheckSvgComponent as CheckIcon } from './icons/check';
export { ExclamationSvgComponent as ExclamationIcon } from './icons/exlamation';
export { RampSvgComponent as RampIcon } from './icons/ramp';
export { TruckSvgComponent as TruckIcon } from './icons/truck';
export { SquareSvgComponent as SquareIcon } from './icons/square';
export { SquareCheckSvgComponent as SquareCheckIcon } from './icons/squareCheck';
export { SquareUncheckSvgComponent as SquareUncheckIcon } from './icons/squareUncheck';
export { CircleCheckSvgComponent as CircleCheckIcon } from './icons/circleCheck';
export { CircleUncheckSvgComponent as CircleUncheckIcon } from './icons/circleUncheck';
export { SquareQuestionSvgComponent as CircleQuestionIcon } from './icons/circleQuestion';
